<template>
  <!-- 通知列表 -->
  <div class="Newslist">
    <div class="Thelistof">
      <div class="search">
        <h5>{{ this.$route.params.id }}</h5>
        <div class="searchbox">
          <el-input placeholder="请输入内容" v-model="input2">
            <template slot="append"
              ><el-button @click="Searchthewrong(input2)" round
                >搜索</el-button
              ></template
            >
          </el-input>
        </div>
      </div>
      <div class="nexts">
        <div
          class="content"
          v-for="(item, index) in listofclasses"
          :key="index"
          @click="jump(item.id)"
        >
          <div class="serial">
            <div class="erialnumber">
              {{ index + ((tarpage.page || 1) - 1) * tarpage.rows + 1 }}.
            </div>

            <div class="sizes">{{ item.name }}</div>
          </div>
          <div class="Thedateof">
            {{ item.putime == undefined ? item.taskfbdate : item.putime }}
          </div>
        </div>
      </div>
      <el-pagination
        @current-change="peges"
        @page-sizes="tarpage.rows"
        class="sezs"
        background
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        :total="tarpage.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { selpublic, seltask } from "../../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      input2: "",
      listofclasses: "",
      tarpage: {
        page: 1,
        rows: 12,
        total: 100,
      },
    };
  },
  created() {
    this.Tobtainalistof();
  },
  mounted() {
    Bus.$emit("activeRouter", "/home");
  },
  methods: {
    // 查询
    // Searchthewrong (item) {
    //   var data = new FormData()
    //   data.append('name', item)
    //   data.append('sort', this.$route.params.id)
    //   data.append('page', 1)
    //   data.append('rows', 100)
    //   selpublic(data).then(res => {
    //     this.listofclasses = res.rows
    //     this.tarpage.total = res.total
    //   })
    // },
    //  跳转
    jump(item) {
      this.$store.commit("zxxixvt", this.$route.params.id);
      this.$router.push(`/Informdetails/${item}`);
    },
    // 获取页面 信息
    Tobtainalistof() {
      var data = new FormData();
      data.append("page", this.tarpage.page);
      data.append("rows", this.tarpage.rows);
      if (this.$route.params.id === "任务发布") {
        data.append("status", "已发布");
        seltask(data).then((res) => {
          this.listofclasses = res.records;
          this.tarpage.total = res.totalCount;
        });
      } else {
        data.append("sort", this.$route.params.id);
        if (this.input2 !== "") {
          data.append("name", this.input2);
        }
        selpublic(data).then((res) => {
          this.listofclasses = res.rows;
          this.tarpage.total = res.total;
        });
      }
    },
    peges(val) {
      this.tarpage.page = val;
      this.Tobtainalistof();
    },
  },
};
</script>
<style lang="scss" scoped>
.Newslist {
  width: 100%;
  margin-top: 10px;
  .Thelistof {
    width: 1042px;
    // height: 200px;
    background: #fff;
    margin: auto;
    padding-bottom: 40px;
    .search {
      display: flex;
      justify-content: space-between;
      padding-left: 19px;
      padding-right: 31px;
      padding-top: 25px;
      margin-bottom: 32px;

      h5 {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .searchbox {
        width: 255px;

        ::v-deep .el-input__inner {
          border-top-left-radius: 15px;
          border-bottom-left-radius: 15px;
          height: 30px;
          // border-top-right-radius: 15px;
          // border-bottom-right-radius: 15px;
        }
        ::v-deep .el-input-group__append {
          margin-left: 100px;
          // line-height: 30px;
          border: 0px;
          background: #fff;

          .el-button {
            position: relative;
            left: -10px;
            top: -1px;
            padding: 0px;
            width: 70px;
            height: 30px;
            background: #4ccaff;
            border: 1px solid #ededed;
            border-radius: 15px;
            color: #fff;
          }
        }
      }
    }
    .nexts {
      min-height: 700px;
    }
    .content {
      padding-top: 15px;
      padding-left: 35px;
      padding-right: 64px;
      // background: #4CCAFF;
      padding-bottom: 15px;
      border-bottom: 1px solid #ededed;
      display: flex;
      justify-content: space-between;
      .serial {
        display: flex;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        .erialnumber {
          margin-right: 10px;
        }
        .sizes {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
      }

      .Thedateof {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
    }
    .content:hover {
      color: #4ccaff;
      cursor: pointer;

      .sizes {
        color: #4ccaff;
      }
      .Thedateof {
        color: #4ccaff;
      }
    }
  }
}
.sezs {
  margin-top: 20px;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}

// 适配手机端
@media (max-width: 768px) {
  .Newslist {
    width: 100%;
    margin-top: 10px;
    .Thelistof {
      width: 100vw;
      .content {
        padding-top: 15px;
        padding-left: 35px;
        padding-right: 64px;
        // background: #4CCAFF;
        padding-bottom: 15px;
        border-bottom: 1px solid #ededed;
        display: block;
        justify-content: space-between;
        text-align: left;
        .serial {
          display: flex;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          .erialnumber {
            margin-right: 10px;
          }
          .sizes {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
        }

        .Thedateof {
          text-align: right;
        }
      }
      .content:hover {
        color: #4ccaff;
        cursor: pointer;

        .sizes {
          color: #4ccaff;
        }
        .Thedateof {
          color: #4ccaff;
        }
      }
    }
  }
}
</style>
